import useSchemas from './useSchemas';

export default useSchemas;
